import {
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';

export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    color: '#8b8fa8',
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    borderBottom: '1px solid rgba(255,255,255,0.07)',
    backgroundColor: '#0f1117',
    paddingTop: '12px',
    paddingBottom: '12px',
    '&:first-of-type': {
      paddingLeft: '35px'
    },
    '&:last-of-type': {
      paddingRight: '35px'
    }
  },
  [`&.${tableCellClasses.body}`]: {
    color: '#d1d5db',
    backgroundColor: 'transparent',
    fontSize: 13,
    borderBottom: '1px solid rgba(255,255,255,0.05)',
    paddingTop: '12px',
    paddingBottom: '12px',
    '&:first-of-type': {
      paddingLeft: '35px'
    },
    '&:last-of-type': {
      paddingRight: '35px'
    }
  }
}));

export const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'rgba(99,102,241,0.05)'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const CustomTable = ({ id, tableHead, children }) => {
  return (
    <TableContainer 
      id={id} 
      component={Paper} 
      elevation={0}
      sx={{
        background: '#141721',
        borderRadius: '12px',
        border: '1px solid rgba(255,255,255,0.07)',
        overflow: 'hidden'
      }}
    >
      <Table
        sx={{
          minWidth: 800,
          boxShadow: 'none',
        }}
        aria-label='simple table'
      >
        <TableHead>
          <TableRow>
            {tableHead.map(el => (
              <StyledTableCell key={el.id} align={el.align}>
                {el.label}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
